exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.inline[data-v-b78458ce] {\r\n  display: inline-block;\r\n  font-size: 14px;\n}\n.v_input_look_div[data-v-b78458ce] {\r\n  width: 200px !important;\n}\r\n", ""]);

// exports
